import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Select, } from 'antd';
import images from '../../themes/appImage'
import { Table, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import { messageslistLoad } from "../../redux/slices/message.slice";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../utils/global-func";
import moment from "moment";
import { imageURL } from "../../redux/Api/apikit";
import { emptySpaceInputHandler } from "../../utils";



const handleChange = (value) => {
    console.log(`selected ${value}`);
};
const numberOfRowOptionList = [
    { value: 'one', label: 10 },
    { value: 'two', label: 20 },
    { value: 'three', label: 25 },
]
let LIST_LIMIT = 10
let OFFSET = 0
let currentSortValue = -1
let sort = "createdAt"
const userListPayload = {
    "offset": 0,
    "limit": 10,
    "search": "",
    "sort": sort,
    "order": currentSortValue
}
const Messages = () => {
    const dispatch = useDispatch()

    const [modal1Open, setModal1Open] = useState(false);
    const [search, setSearch] = useState("")
    const { messagelistData, } = useSelector(state => state.messageReducer)

    const columns = [{
        title: 'ID',
        dataIndex: 'srno',
        key: 'srno',
        sorter: false,
        render: (value, item, index) => (index + 1)
    },

    {
        title: 'Full Name  ',
        dataIndex: 'name',
        key: 'name',
        sorter: false,
        sortDirections: ['ascend', 'descend'],
        title: () => {
            return (
                <div onClick={() => sortHandler("name")} className="sort-icons">
                    <span>Full Name</span> <img src={images.arrowLeft} alt="" />
                </div>
            );
        },

        render: (value, item, index) =>
            <div className="flex items-center organization-image-sec">
                <span><img
                    className="w-7 !important h-7 !important rounded-[100%] object-contain"
                    src={`${imageURL}${item?.user?.avatar}`}
                /></span>
                <div>
                    {item?.user?.firstName} {" "}{item?.user?.lastName}
                </div>
            </div>
    },
    {
        title: 'Query Detail',
        dataIndex: 'query',
        key: 'detail',
        sorter: false,
        sortDirections: ['ascend', 'descend'],
        title: () => {

            return (
                <div onClick={() => sortHandler("query")} className="sort-icons">
                    <span>Query Detail</span> <img src={images.arrowLeft} alt="" />
                </div>
            );
        },

        render: (value, item, index) =>
            <div className="table-detail">
                {item?.query}
            </div>
    },

    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: false,
        render: (value, item, index) =>
            <div className="table-detail">
                {item?.user?.email}
            </div>

    },

    {
        title: 'Sent Date ',
        dataIndex: 'date',
        key: 'date',
        sorter: false,
        sortDirections: ['ascend', 'descend'],
        title: () => {

            return (
                <div onClick={() => sortHandler("date")} className="sort-icons">
                    <span>Sent Date</span> <img src={images.arrowLeft} alt="" />
                </div>
            );
        },
        render: (value, item, index) =>
            <div className="table-detail">
                {moment(item?.user?.createdAt).format('MMMM D, YYYY')}
            </div>
    },

    ];

    useEffect(() => {
        dispatch(messageslistLoad(userListPayload))
    }, [])
    // P A G I N A T I O N 

    // --S T A T E--
    const START = useMemo(() => OFFSET + 1, [messagelistData?.list]);
    const TOTAL_LIST_ITEMS = useMemo(() => messagelistData?.pagination?.totalCount, [messagelistData?.list])
    const END = useMemo(() => (Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS)), [messagelistData.list]);

    // --A C T I O N S--

    const paginationHandler = useCallback((type) => {
        if (type === "pre") {
            OFFSET = OFFSET - LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: sort,
                order: currentSortValue
            }
            dispatch(messageslistLoad(data));
        } else {
            OFFSET = OFFSET + LIST_LIMIT
            const data = {
                offset: OFFSET,
                limit: LIST_LIMIT,
                search: search,
                sort: "createdAt",
                order: -1
            }
            dispatch(messageslistLoad(data));
        }
    }, [messagelistData.list])

    const numberOfRowHandler = useCallback((ddateStringate, dataObj) => {
        LIST_LIMIT = dataObj.label
        OFFSET = 0
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(messageslistLoad(data));
    }, [messagelistData.list])

    const searchHandler = useCallback((e) => {
        if (emptySpaceInputHandler(e) || e.target.value.length == "") {
            LIST_LIMIT = 10
            OFFSET = 0
            setSearch(emptySpaceInputHandler(e))
            const data = {
                offset: 0,
                limit: 10,
                search: emptySpaceInputHandler(e).trim(),
                order: -1
            }
            debounce(() => dispatch(messageslistLoad(data)))
        }
    }, [messagelistData.list]);

    const sortHandler = useCallback((sort) => {
        sort = sort
        currentSortValue = currentSortValue == -1 ? 1 : -1
        const data = {
            offset: OFFSET,
            limit: LIST_LIMIT,
            search: search,
            sort: sort,
            order: currentSortValue
        }
        dispatch(messageslistLoad(data));
    }, [messagelistData.list])


    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Messages</h1>
                        {/* <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p> */}
                    </div>
                    <div className="queries-rec">
                        <button >Total Queries Received: <span>{TOTAL_LIST_ITEMS}</span></button>
                    </div>
                </div>
                <section>
                    <div className=" messages-tables">
                        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 system-line">
                            <input type="text" value={search} onChange={searchHandler} className="iocn-search  search-bar" placeholder="Search message" />
                            {/* Version 2 */}
                            {/* <div className="top-checkbox">
                                <Select
                                    defaultValue="Filter"
                                    onChange={handleChange}
                                    options={[
                                        { value: 'one', label: '1 months' },
                                        { value: 'two', label: '3 months' },
                                        { value: 'three', label: '6 months' },
                                    ]}
                                />
                            </div> */}
                        </div>

                        <Table
                            dataSource={messagelistData?.list||[]}
                            columns={columns}
                            showSorterTooltip={false}
                            pagination={{
                                current: 0,
                                pageSize: 0,
                                total: TOTAL_LIST_ITEMS,
                            }}
                        />

                        {TOTAL_LIST_ITEMS > 10 && <div className="footer-section">
                            <div className="foot-main-div">
                                <div className="rows">
                                    <div className="row-per-page">
                                        <p>Rows per page</p>
                                    </div>

                                    <div className="top-checkbox fot-select">
                                        <Select
                                            defaultValue={LIST_LIMIT}
                                            onChange={numberOfRowHandler}
                                            options={numberOfRowOptionList}
                                        />
                                    </div>
                                </div>

                                <div className="page-count">
                                    <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                                </div>

                                <div className="back-and-next">
                                    {/* <span><img src={images.back} alt="back" /></span> */}
                                    <span onClick={() => OFFSET !== 0 && paginationHandler("pre")}><img src={images.per} alt="back" /></span>
                                    <span onClick={() => OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS && paginationHandler("next")}><img src={images.new} alt="back" /></span>
                                    {/* <span><img src={images.next} alt="back" /></span> */}
                                </div>

                            </div>

                        </div>}
                    </div>
                </section>
            </div>


            {/* Add Problem Type */}
            <Modal
                title=""
                className="modal-update"
                centered
                visible={modal1Open}
                closable={true}
                onCancel={() => setModal1Open(false)}
                footer={false}
                width={600}  >
                <div className="add-user-popup">
                    <div className="modal-add-user">
                        <h1>Message</h1>

                    </div>


                    <div className="wrapper_line">

                        <div className="form-group">
                            <div className="textarea-label">
                                <label>{appconstant.queryDetail}</label>
                                <p>0/500</p>
                            </div>
                            <textarea
                                rows="14" cols="50"
                                className='form-control-textarea'
                                type='textarea'
                                placeholder='Add Query Detail' />
                        </div>
                    </div>
                </div>


                <div className="click-to-upload problem-btn-ms">
                    <div className="create-inner-circle-btn save-btn-mo ">
                        <button>Reply through email</button>
                    </div>
                </div>



            </Modal>
        </div>

    )
}
export default Messages

